const hashString = (value) => {
  const str = String(value ?? '');
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash;
};

const hsl = (h, s, l) => `hsl(${Math.round(h)} ${Math.round(s)}% ${Math.round(l)}%)`;

export const getUserTheme = (username) => {
  const seed = hashString((username ?? '').trim().toLowerCase() || 'anonymous');
  const hue = seed % 360;

  const accent = hsl(hue, 78, 52);
  const accentSoft = hsl(hue, 78, 40);
  const background = hsl(hue, 22, 12);
  const backgroundSoft = hsl(hue, 22, 18);

  return {
    hue,
    accent,
    accentSoft,
    background,
    backgroundSoft,
  };
};

export const applyThemeToDocument = (theme) => {
  if (typeof document === 'undefined' || !document.documentElement) return;
  const root = document.documentElement;
  root.style.setProperty('--player-accent', theme?.accent ?? '');
  root.style.setProperty('--player-accent-soft', theme?.accentSoft ?? '');
  root.style.setProperty('--player-bg', theme?.background ?? '');
  root.style.setProperty('--player-bg-soft', theme?.backgroundSoft ?? '');
  const tag = document.querySelector('meta[name="theme-color"]');
  if (tag && theme?.background) tag.setAttribute('content', theme.background);
};
